'use es6';

import { createSelector } from 'reselect';

const getBlogUsageLimitsState = state => state.blogUsageLimits;

export const getBlogUsageLimit = createSelector(getBlogUsageLimitsState, contentUsage => contentUsage.limit);
export const getBlogQuantityUsed = createSelector(getBlogUsageLimitsState, contentUsage => contentUsage.quantityUsed);
export const getIsOverBlogLimit = createSelector([getBlogUsageLimit, getBlogQuantityUsed], (limit, used) => limit !== null && used > limit);
export const getNumBlogsMoreThanLimitDifference = createSelector([getBlogUsageLimit, getBlogQuantityUsed], (limit, used) => limit !== null && used > limit ? used - limit : 0);